export const PRE_ACCESS_PAGE_SIZE = 1000;

export const PRE_ACCESS_TOTAL_COLUMN_NAMES = ["unitQuantityTotal", "unitQuantityAvailable"];
